import React from "react"
import { useSelector } from "react-redux";
import { onKeyDown } from "../../service";
import classes from './ChooseTypePopup.module.css'

const ChooseTypePopup = ({ setTypeLesson, lessonsList, title, typeTitle }) => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.LessonsContainer}>
            <div className={classes.PreWizard}>
                <div className={classes.TitleContainer}>
                    <div className={classes.Circle}>+</div>
                    <p className={classes.Title}>{title}</p>
                </div>
                <p className={classes.TypeTitle}>{typeTitle}</p>
                <div className={classes.AllCard}>
                    {lessonsList && lessonsList.map((lesson, index) =>
                        <div key={index} className={classes.CardContainer} onClick={() => setTypeLesson(lesson.type)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setTypeLesson(lesson.type))}>
                            <div className={classes.Card}>
                                <img src={lesson.icon} className={classes.Icon} />
                                <p className={classes.Name}>{texts[lesson.name]}</p>
                            </div>
                            <p className={classes.Description}>{texts[lesson.description]}</p>
                        </div>)
                    }
                </div>
            </div>
        </div>
    )
}

export default ChooseTypePopup;